// MB-I18N-2A — app FR (extrait de LanguageContext, valeurs inchangées).
export default {
  "nav.account": "Compte",
  "nav.wallet": "Portefeuille",
  "nav.menu": "Menu",
  "nav.location": "Adresse",
  "nav.cart": "Panier",
  "nav.home": "Accueil",
  "nav.order": "Commander",
  "nav.pay": "Payer",
  "nav.news": "Actus",
  "nav.stores": "Boutiques",
  "news.title": "Actualités",
  "news.heading": "Actus SUPERKAWA",
  "news.coming_soon_title": "Bientôt disponible",
  "news.coming_soon_desc": "Nouveautés, promotions, événements et messages de vos boutiques arriveront ici très prochainement.",
  "news.notify_hint": "Vous serez notifié dès le lancement",
  "news.empty_feed": "Aucune actualité disponible pour le moment.",
  "news.empty_feed_hint": "Les nouveautés et promotions de vos boutiques apparaîtront ici.",
  "news.back_home": "Retour à l’accueil",
  "account.good_morning": "Bonjour",
  "account.good_afternoon": "Bon après-midi",
  "account.good_evening": "Bonsoir",
  "account.loyalty_points": "Points de fidélité",
  "account.points": "points",
  "account.points_to_free": "points pour boisson gratuite",
  "account.free_drinks": "Vous avez {count} boisson(s) gratuite(s) !",
  "account.welcome_offer": "Offre de bienvenue",
  "account.welcome_offer_progress": "Dépensez encore {amount} DA pour un café gratuit !",
  "account.history": "Historique",
  "account.favorites": "Favoris",
  "account.support": "Aide",
  "account.settings": "Paramètres",
  "account.recent_orders": "Commandes récentes",
  "account.sign_out": "Se déconnecter",
  "account.items": "article(s)",
  "menu.title": "Menu",
  "menu.our_menu": "Notre carte",
  "menu.discover": "Découvrez notre sélection premium",
  "menu.espresso": "Espresso",
  "menu.coldbrew": "Cold Brew",
  "menu.froid": "Froid",
  "menu.cookies": "Cookies",
  "menu.hot": "Chaud",
  "menu.chaud": "Chaud",
  "menu.price_todefine": "Prix à définir",
  "menu.cold": "Froid",
  "menu.snacks": "Snacks",
  "menu.packs": "Packs",
  "menu.size": "Taille",
  "menu.option": "Option",
  "menu.vanilla_ice_cream": "Glace vanille",
  "menu.view_recipe": "Voir recette",
  "menu.recipe": "Recette",
  "menu.recipe_difficulty": "Difficulté",
  "menu.recipe_ingredients": "Ingrédients",
  "menu.recipe_steps": "Étapes",
  "menu.recipe_tip": "Astuce",
  "menu.recipe_loading": "Chargement…",
  "menu.recipe_unavailable": "Recette indisponible",
  "menu.recipe_close": "Fermer",
  "menu.quantity": "Quantité",
  "menu.add_to_cart": "Ajouter au panier",
  "menu.add": "Ajouter",
  "menu.view_cart": "Voir le panier",
  "menu.items_in_cart": "article(s)",
  "menu.estimated_prep": "Préparation estimée : ~10 min",
  "menu.added_to_cart": "Ajouté au panier",
  "menu.coffees_included": "cafés inclus",
  "menu.cash_only": "Achat au comptoir • Paiement en espèces",
  "menu.save": "Économisez",
  "menu.no_products": "Aucun produit disponible",
  "menu.load_error": "Impossible de charger le menu",
  "menu.choose_shop_first": "Choisissez d'abord un établissement",
  "menu.pause_salat": "Pause Salât",
  "menu.pause_salat_msg": "Nous reprenons le service dans quelques minutes",
  "menu.pause_simple": "Boutique en pause",
  "menu.pause_simple_msg": "Nous reprenons bientôt",
  "menu.status_closed": "Boutique fermée",
  "menu.status_closed_msg": "Cet établissement est fermé pour le moment",
  "menu.status_maintenance": "Maintenance en cours",
  "menu.status_maintenance_msg": "Cet établissement est temporairement indisponible",
  "menu.status_suspended": "Boutique indisponible",
  "menu.status_suspended_msg": "Cet établissement n'accepte pas de commande pour le moment",
  "menu.status_until": "Reprise prévue",
  "shop.choose_title": "Choisissez votre boutique",
  "shop.country_dz": "Algérie",
  "shop.country_fr": "France",
  "shop.country_ma": "Maroc",
  "shop.country_sa": "Arabie Saoudite",
  "order.received_title": "Commande reçue",
  "order.received_msg": "Votre commande a été reçue et sera bientôt prise en charge.",
  "order.preparing_title": "En préparation",
  "order.preparing_msg": "Votre commande est en cours de préparation.",
  "order.ready_title": "Commande prête !",
  "order.ready_msg": "Rendez-vous au comptoir pour récupérer votre commande.",
  "order.step_received": "Reçue",
  "order.step_preparing": "En préparation",
  "order.step_ready": "Prête",
  "order.number": "N°",
  "order.total": "Total",
  "order.subtotal_ht": "Total HT",
  "order.vat": "TVA",
  "order.total_ttc": "Total TTC",
  "order.pickup": "Retrait",
  "order.estimated_time": "Temps estimé",
  "order.refresh_status": "Rafraîchir le statut",
  "order.new_order": "Nouvelle commande",
  "order.points_earned": "+{points} points gagnés",
  "home.hello": "Bonjour",
  "home.welcome_back": "Bon retour",
  "home.loyalty_member": "Membre fidélité",
  "home.points_subtitle": "Cumulez des points à chaque visite",
  "home.view_wallet": "Voir mon portefeuille",
  "home.your_shop": "Votre boutique",
  "home.choose_shop": "Choisir une boutique",
  "home.no_shop_desc": "Sélectionnez une boutique pour commencer",
  "home.shop_active": "Ouvert",
  "home.shop_inactive": "Indisponible",
  "home.my_account": "Mon compte",
  "home.qr_subtitle": "Présentez ce code au comptoir",
  "home.next_reward_cta": "Voir les récompenses",
  "home.recent_activity": "Activité récente",
  "home.view_all": "Tout voir",
  "home.no_rewards": "Aucune récompense disponible pour cette boutique",
  "home.no_activity": "Aucun mouvement récent",
  "location.title": "Nos adresses",
  "location.open": "Ouvert",
  "location.closed": "Fermé",
  "location.closed_today": "Fermé aujourd'hui",
  "location.hours": "Horaires d'ouverture",
  "location.no_stores": "Aucune boutique disponible",
  "location.near_me": "Boutiques près de moi",
  "location.nearest": "La plus proche",
  "location.locating": "Localisation…",
  "location.location_denied": "Localisation indisponible — choisissez votre boutique",
  "location.directions": "Itinéraire",
  "shop.detail_back": "Retour",
  "shop.detail_back_explore": "Retour aux établissements",
  "shop.detail_notfound_title": "Établissement introuvable",
  "shop.detail_notfound_desc": "Cette boutique n'existe pas ou n'est plus disponible.",
  "shop.section_info": "Informations",
  "shop.section_hours": "Horaires",
  "shop.section_contact": "Contact",
  "shop.distance_from_you": "depuis votre position",
  "shop.action_share": "Partager",
  "shop.share_copied": "Lien copié",
  "shop.share_failed": "Impossible de copier le lien",
  "shop.section_reviews": "Avis vérifiés",
  "shop.reviews_verified_badge": "Avis vérifié",
  "shop.reviews_empty": "Aucun avis pour le moment.",
  "shop.reviews_count_suffix": "avis vérifiés",
  "shop.reviews_count_suffix_one": "avis vérifié",
  "shop.reviews_merchant_reply": "Réponse du commerçant",
  "shop.reviews_verified_note": "Chaque avis provient d’une commande réelle passée dans cet établissement.",
  "shop.reviews_anonymous": "Client vérifié",
  "explore.search_placeholder": "Rechercher un nom, une adresse, un pays…",
  "explore.no_results": "Aucun établissement ne correspond à votre recherche",
  "explore.view_menu": "Voir le menu",
  "explore.results": "établissement(s)",
  "shop.country_sn": "Sénégal",
  "shop.country_tn": "Tunisie",
  "shop.country_id": "Indonésie",
  "type.coffee_shop": "Coffee shop",
  "type.fast_food": "Fast food",
  "type.salon_de_the": "Salon de thé",
  "type.boulangerie": "Boulangerie",
  "type.restaurant": "Restaurant",
  "cart.title": "Votre panier",
  "cart.empty": "Votre panier est vide",
  "cart.empty_subtitle": "Ajoutez des articles depuis le menu",
  "cart.pickup_location": "Lieu de retrait",
  "cart.select_store": "Sélectionnez une boutique",
  "cart.payment_method": "Mode de paiement",
  "cart.wallet": "Portefeuille",
  "cart.balance": "Solde",
  "cart.pay_counter": "Payer au comptoir",
  "cart.cash": "Espèces",
  "cart.insufficient_balance": "Solde insuffisant. Rechargez au comptoir ou choisissez un autre mode de paiement.",
  "cart.total": "Total",
  "cart.place_order": "Commander",
  "cart.order_placed": "Commande passée !",
  "cart.order_received": "Votre commande {number} a été reçue",
  "cart.estimated_ready": "Temps de préparation estimé",
  "cart.mins": "min",
  "cart.points_earned": "Points gagnés",
  "cart.another_order": "Passer une autre commande",
  "cart.order_failed": "Échec de la commande",
  "status.pending": "En attente",
  "status.preparing": "En préparation",
  "status.ready": "Prêt",
  "status.completed": "Terminé",
  "status.cancelled": "Annulé",
  "loyalty.bronze": "Bronze",
  "loyalty.silver": "Argent",
  "loyalty.gold": "Or",
  "loyalty.member": "Membre",
  "cart.empty_toast": "Votre panier est vide",
  "cart.insufficient_short": "Solde insuffisant",
  "cart.order_sent": "Commande envoyée",
  "cart.order_error": "Erreur lors de la commande",
  "cart.change": "Changer",
  "cart.choose_shop": "Choisir une boutique",
  "cart.coming_soon_methods": "Prochainement disponibles",
  "cart.soon": "Bientôt",
  "pay.title": "Payer",
  "pay.subtitle": "Finalisez votre commande",
  "pay.cart_empty": "Panier vide",
  "pay.add_from_menu": "Ajoutez des produits depuis le menu",
  "pay.view_menu": "Voir le menu",
  "pay.choose_shop_title": "Choisissez un shop",
  "pay.choose_shop_subtitle": "Sélectionnez votre boutique SUPERKAWA pour voir les options de paiement disponibles.",
  "pay.your_cart": "Votre panier ({count})",
  "pay.payment_method": "Mode de paiement",
  "pay.insufficient_long": "Solde insuffisant. Rechargez votre portefeuille ou choisissez un autre mode de paiement.",
  "pay.confirm_order": "Confirmer la commande",
  "pay.balance": "Solde",
  "account.personal_info": "Informations personnelles",
  "account.name": "Nom",
  "account.phone": "Téléphone",
  "account.email": "Email",
  "account.security": "Sécurité",
  "account.password": "Mot de passe",
  "account.security_pin": "PIN de sécurité",
  "account.configure_pin": "Configurer un PIN",
  "account.preferences": "Préférences",
  "account.language": "Langue",
  "account.notifications": "Notifications",
  "account.notifications_on": "Activées",
  "account.notifications_off": "Désactivées",
  "account.help": "Aide et support",
  "account.assistance": "Assistance",
  "account.danger_zone": "Zone de danger",
  "account.delete_account": "Supprimer mon compte",
  "account.delete_warning": "Cette action est irréversible",
  "account.logout": "Déconnexion",
  "account.app_version": "SUPERKAWA® v1.0.0",
  "account.not_set": "Non renseigné",
  "account.edit_name": "Modifier le nom",
  "account.edit_email": "Modifier l'email",
  "account.change_password": "Changer le mot de passe",
  "account.current_password": "Mot de passe actuel",
  "account.new_password": "Nouveau mot de passe",
  "account.confirm_password": "Confirmer le mot de passe",
  "account.your_name_placeholder": "Votre nom",
  "account.email_placeholder": "votre@email.com",
  "account.setup_pin_title": "Configurer le PIN",
  "account.setup_pin_desc": "Créez un code PIN à 4 chiffres pour sécuriser vos paiements.",
  "account.delete_title": "Supprimer le compte",
  "account.delete_confirm_msg": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible et vous perdrez :",
  "account.delete_loss_balance": "Votre solde portefeuille",
  "account.delete_loss_points": "Vos points fidélité",
  "account.delete_loss_history": "Votre historique de commandes",
  "account.delete_btn": "Supprimer",
  "account.modifications_saved": "Modifications enregistrées",
  "account.delete_support_msg": "Veuillez contacter le support pour supprimer votre compte",
  "account.support_msg": "Support : support@superkawa.co",
  "account.delete_confirm_title": "Confirmer la suppression du compte",
  "account.save_error": "Échec de l'enregistrement",
  "account.b2b.section_title": "Facturation professionnelle",
  "account.b2b.label": "Profils professionnels (B2B)",
  "account.b2b.manage": "Gérer mes profils",
  "account.b2b.empty": "Aucun profil professionnel. Ajoutez-en un pour vos factures B2B.",
  "account.b2b.add": "Ajouter un profil",
  "account.b2b.edit_title": "Modifier le profil",
  "account.b2b.create_title": "Nouveau profil professionnel",
  "account.b2b.default_badge": "Par défaut",
  "account.b2b.set_default": "Définir par défaut",
  "account.b2b.legal_name": "Raison sociale",
  "account.b2b.country_code": "Pays d'immatriculation",
  "account.b2b.registration_number": "Numéro d'immatriculation",
  "account.b2b.tax_identifier": "Identifiant fiscal",
  "account.b2b.vat_identifier": "TVA intracommunautaire",
  "account.b2b.address_section": "Adresse de facturation",
  "account.b2b.street": "Rue",
  "account.b2b.postal_code": "Code postal",
  "account.b2b.city": "Ville",
  "account.b2b.addr_country": "Pays",
  "account.b2b.contact_section": "Contact",
  "account.b2b.contact_name": "Nom du contact",
  "account.b2b.contact_email": "Email",
  "account.b2b.contact_phone": "Téléphone",
  "account.b2b.set_as_default": "Profil par défaut",
  "account.b2b.delete_confirm": "Supprimer ce profil professionnel ?",
  "account.b2b.saved": "Profil enregistré",
  "account.b2b.deleted": "Profil supprimé",
  "account.b2b.save_error": "Erreur lors de l'enregistrement",
  "account.b2b.load_error": "Erreur lors du chargement des profils",
  "orders.section_title": "Commandes",
  "orders.section_subtitle": "Consulter mes commandes passées",
  "orders.title": "Mes commandes",
  "orders.empty": "Aucune commande pour l'instant.",
  "orders.prev": "Précédent",
  "orders.next": "Suivant",
  "orders.status.pending": "Reçue",
  "orders.status.preparing": "En préparation",
  "orders.status.ready": "Prête",
  "orders.status.completed": "Terminée",
  "orders.status.cancelled": "Annulée",
  "orders.payment.paid": "Payée",
  "orders.payment.unpaid": "Non payée",
  "orders.download_receipt": "Télécharger le reçu",
  "orders.download_invoice": "Télécharger la facture",
  "orders.receipt_unavailable": "Reçu indisponible pour le moment.",
  "orders.invoice_unavailable": "Facture indisponible pour le moment.",
  "orders.download_error": "Erreur lors du téléchargement.",
  "reviews.my_reviews": "Mes avis",
  "reviews.section_subtitle": "Consulter les avis que j'ai laissés",
  "reviews.leave": "Laisser un avis",
  "reviews.already": "Avis déposé",
  "reviews.dialog_title": "Laisser un avis",
  "reviews.your_rating": "Votre note",
  "reviews.your_comment": "Votre commentaire",
  "reviews.comment_placeholder": "Partagez votre expérience (optionnel)",
  "reviews.submit": "Envoyer l'avis",
  "reviews.submitted": "Avis envoyé. Merci !",
  "reviews.error": "Erreur lors de l'envoi de l'avis.",
  "reviews.rating_required": "Veuillez sélectionner une note.",
  "reviews.merchant_reply": "Réponse du commerçant",
  "reviews.empty": "Vous n'avez pas encore laissé d'avis.",
  "reviews.status.published": "Publié",
  "reviews.status.hidden": "Masqué",
  // MB-I18N-5 — Tunnel d'onboarding (création d'établissement)
  "onboarding.brand": "SUPERKAWA OS",
  "onboarding.steps.establishment": "Établissement",
  "onboarding.steps.needs": "Besoins",
  "onboarding.steps.payment": "Paiement",
  "onboarding.steps.recommendation": "Recommandation",
  "onboarding.needs.pos": "POS & Encaissement",
  "onboarding.needs.loyalty": "Fidélité",
  "onboarding.needs.wallet": "Wallet",
  "onboarding.needs.recipes": "Recettes & Standardisation",
  "onboarding.needs.stock": "Stock & Inventaires",
  "onboarding.payments.card": "Carte bancaire",
  "onboarding.payments.transfer": "Virement bancaire",
  "onboarding.toast.reco_error": "Impossible de calculer la recommandation pour le moment",
  "onboarding.toast.markets_loading": "Chargement des pays en cours…",
  "onboarding.toast.markets_error": "Catalogue des pays indisponible. Veuillez réessayer.",
  "onboarding.errors.market_not_supported": "Le marché {country_code} n’est pas encore pris en charge.",
  "onboarding.toast.name_required": "Veuillez renseigner le nom de l’établissement",
  "onboarding.toast.type_required": "Veuillez sélectionner le type d’établissement",
  "onboarding.toast.specialty_required": "Veuillez choisir une spécialité pour votre restaurant",
  "onboarding.toast.country_required": "Veuillez sélectionner votre pays",
  "onboarding.toast.address_required": "Veuillez renseigner l’adresse de l’établissement",
  "onboarding.toast.email_required": "Veuillez renseigner l’email professionnel",
  "onboarding.toast.email_invalid": "Veuillez saisir un email professionnel valide",
  "onboarding.toast.phone_required": "Veuillez renseigner le téléphone professionnel",
  "onboarding.toast.manager_required": "Veuillez renseigner le nom du dirigeant / responsable légal",
  "onboarding.toast.fields_required": "Veuillez compléter les champs obligatoires (*)",
  "onboarding.toast.created": "Boutique « {name} » créée en période d'essai.",
  "onboarding.toast.create_error": "Erreur lors de la création de la boutique",
  "onboarding.step1.title": "Votre établissement",
  "onboarding.step1.name_label": "Nom de l’établissement",
  "onboarding.step1.name_placeholder": "Le Petit Kawa",
  "onboarding.step1.type_label": "Type d’établissement",
  "onboarding.step1.types_loading": "Chargement des types…",
  "onboarding.step1.types_error": "Impossible de charger les types d’établissement.",
  "onboarding.step1.retry": "Réessayer",
  "onboarding.step1.specialty_label": "Spécialité du restaurant",
  "onboarding.step1.service_mode_label": "Comment souhaitez-vous organiser votre point de vente ?",
  "onboarding.step1.service_single_title": "Une seule caisse",
  "onboarding.step1.service_single_desc": "Tout le service depuis un seul terminal.",
  "onboarding.step1.service_prep_title": "Caisse + écran de préparation",
  "onboarding.step1.service_prep_desc": "La caisse encaisse. Un écran dédié affiche les commandes à préparer.",
  "onboarding.step1.recommended": "Recommandé",
  "onboarding.step1.country_label": "Pays",
  "onboarding.step1.markets_loading": "Chargement des pays…",
  "onboarding.step1.markets_error": "Catalogue des pays indisponible. Impossible de continuer sans pays.",
  "onboarding.step1.country_placeholder": "Sélectionnez votre pays",
  "onboarding.step1.address_label": "Adresse",
  "onboarding.step1.address_placeholder": "12 rue des Oliviers, Alger",
  "onboarding.step1.phone_label": "Téléphone professionnel",
  "onboarding.step1.phone_placeholder": "+213 661 00 00 00",
  "onboarding.step1.email_label": "Email professionnel",
  "onboarding.step1.email_placeholder": "contact@votre-etablissement.com",
  "onboarding.step1.manager_label": "Nom du dirigeant / responsable légal",
  "onboarding.step1.manager_placeholder": "Prénom et nom du responsable légal",
  "onboarding.step1.regnum_label": "Numéro d’établissement professionnel",
  "onboarding.step1.regnum_placeholder": "RC / SIRET / NIF…",
  "onboarding.step2.title": "Vos besoins",
  "onboarding.step2.subtitle": "Sélectionnez ce qui compte pour votre activité.",
  "onboarding.step3.title": "Paiement préféré",
  "onboarding.step3.subtitle": "Comment souhaitez-vous régler votre abonnement ?",
  "onboarding.step4.title": "Notre recommandation",
  "onboarding.step4.reco_loading": "Calcul en cours…",
  "onboarding.step4.reco_badge": "Formule conseillée",
  "onboarding.step4.trial_note": "Votre boutique démarre en période d’essai. Vous pourrez ajuster votre formule à tout moment.",
  "onboarding.nav.back": "Précédent",
  "onboarding.nav.continue": "Continuer",
  "onboarding.nav.create": "Créer ma boutique",
  "onboarding.market_activation.message": "Vous souhaitez activer votre pays ? Contactez SUPERKAWA. L'activation peut être effectuée immédiatement.",
  "onboarding.market_activation.contact": "Contacter SUPERKAWA",
  // MB-I18N-BACKEND-1 — Recommandation (codes backend traduits côté frontend)
  "onboarding.pricing.per_month": "/ mois",
  "onboarding.reco_explanation.needs_covered_by_plan": "Vos besoins sont couverts par la formule {plan} (application client, POS, wallet & fidélité).",
  "onboarding.reco_explanation.recipes_need_pro": "La standardisation des recettes nécessite la formule {plan}.",
  "onboarding.reco_explanation.stock_needs_full": "La gestion des stocks nécessite la formule {plan}.",
  "onboarding.reco_explanation.unknown": "Formule recommandée selon vos besoins.",
  "onboarding.establishment_types.coffee_shop": "Coffee Shop",
  "onboarding.establishment_types.salon_de_the": "Salon de Thé",
  "onboarding.establishment_types.boulangerie": "Boulangerie",
  "onboarding.establishment_types.restaurant": "Restaurant",
  "onboarding.establishment_types.unknown": "Établissement",
  "onboarding.specialties.pizza": "Pizza",
  "onboarding.specialties.burger": "Burger",
  "onboarding.specialties.kebab": "Kebab",
  "onboarding.specialties.poulet": "Poulet",
  "onboarding.specialties.sushi": "Sushi",
  "onboarding.specialties.poke": "Poké",
  "onboarding.specialties.salades": "Salades",
  "onboarding.specialties.japonais": "Japonais (Ramen & Plats)",
  "onboarding.specialties.chinois": "Chinois",
  "onboarding.specialties.vietnamien": "Vietnamien",
  "onboarding.specialties.thai": "Thaï",
  "onboarding.specialties.indien": "Indien",
  "onboarding.specialties.pakistanais": "Pakistanais",
  "onboarding.specialties.libanais": "Libanais",
  "onboarding.specialties.italien": "Italien",
  "onboarding.specialties.mexicain": "Mexicain",
  "onboarding.specialties.africain": "Africain",
  "onboarding.specialties.vegetarien": "Végétarien",

  // MB-I18N-CLIENT-EXTRAS — Recharge en ligne (Wallet)
  "onlineRecharge.title": "Recharge en ligne",
  "onlineRecharge.current_balance": "Solde actuel",
  "onlineRecharge.choose_amount": "Choisir le montant",
  "onlineRecharge.custom_amount": "Ou entrer un montant personnalisé",
  "onlineRecharge.minimum": "Minimum : {amount}",
  "onlineRecharge.min_amount_toast": "Montant minimum : {amount}",
  "onlineRecharge.amount_to_recharge": "Montant à recharger",
  "onlineRecharge.proceed": "Procéder au paiement",
  "onlineRecharge.card_soon_info": "Le paiement par carte sera disponible prochainement. Pour recharger maintenant, rendez-vous en boutique.",
  "onlineRecharge.create_error": "Erreur lors de la création du paiement",
  "onlineRecharge.pending_title": "Paiement en attente",
  "onlineRecharge.pending_desc": "Votre demande de recharge a été enregistrée. Le paiement par carte sera bientôt disponible.",
  "onlineRecharge.reference": "Référence",
  "onlineRecharge.amount": "Montant",
  "onlineRecharge.status": "Statut",
  "onlineRecharge.status_pending": "En attente de paiement",
  "onlineRecharge.pending_info": "Le paiement par carte bancaire (CIB/Edahabia/Stripe) sera activé prochainement. En attendant, vous pouvez recharger en boutique auprès du staff.",
  "onlineRecharge.success_title": "Paiement réussi !",
  "onlineRecharge.success_desc": "Votre portefeuille a été rechargé",
  "onlineRecharge.new_balance": "Nouveau solde",
  "onlineRecharge.new_recharge": "Nouvelle recharge",
  "onlineRecharge.back_to_wallet": "Retour au portefeuille",
  "onlineRecharge.failed_title": "Paiement échoué",
  "onlineRecharge.failed_desc": "Le paiement n'a pas pu être traité",
  "onlineRecharge.retry": "Réessayer",

  // MB-I18N-CLIENT-EXTRAS — Écran de préparation (KDS)
  "preparation.title": "Écran de préparation",
  "preparation.badge": "PRÉPARATION",
  "preparation.no_shop": "Aucune boutique sélectionnée.",
  "preparation.back_to_register": "Retour à la Caisse",
  "preparation.refresh": "Rafraîchir",
  "preparation.register": "Caisse",
  "preparation.col_pending": "Nouvelles",
  "preparation.col_preparing": "En préparation",
  "preparation.col_ready": "Prêtes",
  "preparation.action_prepare": "Préparer",
  "preparation.action_ready": "Prêt",
  "preparation.action_finish": "Terminer",
  "preparation.payment_required": "Paiement requis",
  "preparation.payment_required_hint": "Encaisser à la Caisse avant de terminer",
  "preparation.empty": "Aucune commande",
  "preparation.loyalty_customer": "Client fidélité",
  "preparation.counter": "Comptoir",
  "preparation.no_items": "Aucun article",
  "preparation.total": "Total",
  "preparation.toast_completed_points": "Commande terminée ! +{points} points fidélité",
  "preparation.toast_updated": "Commande mise à jour",
  "preparation.toast_update_error": "Erreur de mise à jour",
};
